var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"search-results-list-item"},[(_vm.item.Title)?_c('h3',{class:[_vm.item.Description ? 'mb-2' : 'mb-0']},[_c('a',{attrs:{"href":_vm.item.Path}},[_vm._v(_vm._s(_vm.item.Title))])]):_vm._e(),(_vm.item.Description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.item.Description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }